export const arrayLast = (array) => array[array.length - 1];
